import { AllCompaniesThemeSizeConfig } from './types';

const large: AllCompaniesThemeSizeConfig = {
  allCompanies: {},
};

export default large;
